<template>
    <div id="aia_footer">
        <MassFootMenu
            v-if="theme == 'mass'"
            :pageName="pageName"
            @clickBackHeader="clickBack" />
        <PrestigeFootMenu
            v-if="theme == 'prestige'"
            :pageName="pageName"
            @clickBackHeader="clickBack" />
    </div>
</template>
<script>
import MassFootMenu from './component/MassFootMenu.vue';
import PrestigeFootMenu from './component/PrestigeFootMenu.vue';
export default {
    name: 'AIAFootMenu',
    components: {
        MassFootMenu,
        PrestigeFootMenu
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        },
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        }
    },
    props: {
        pageName: String,
        modalController: Object,
    },
    methods: {
        //event
        clickBack: function () {
            this.$emit('clickBack');
        }
    }
}
</script>
<style lang="scss" scoped>
</style>
